<body class="m-0 min-h-[100dvh] w-full overflow-hidden bg-transparent">
    <main class="min-h-[100dvh] w-full">
        <img src="assets/cooksplash-f.png" alt="erbsen.app" class="block h-screen w-screen object-contain" />
    </main>
</body>